export default "/signup/_next/static/chunks/fonts/CircularStd-Black-ee48dddaaeed4644339a83fe134eef9f.otf";